import { Controller } from '@hotwired/stimulus'

// Pausa las animaciones en bucle de un bloque de la portada de cuentas mientras no está en
// pantalla (cuadrícula de las guías, ENH-RNK-7023): pone la clase is-fuera.
export default class extends Controller {
  connect () {
    if (!('IntersectionObserver' in window)) return

    this.observador = new IntersectionObserver((entradas) => {
      this.element.classList.toggle('is-fuera', !entradas.some((entrada) => entrada.isIntersecting))
    }, { threshold: 0 })
    this.observador.observe(this.element)
  }

  disconnect () {
    this.observador?.disconnect()
  }
}
